import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import QuickNavigationButtonImpl from './quick-navigation-button.js';
import { noop } from 'mojito/utils';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Quick navigation button component.
 * Typically, used inside page header to trigger fast content navigation flow.
 *
 * @class QuickNavigationButton
 * @memberof Mojito.Presentation.Components
 */

/**
 * QuickNavigationButton prop types.
 *
 * @property {string} [title] - Title label. By default will be rendered on top.
 * @property {string} [subTitle] - Sub title label. By default will be rendered below title.
 * @property {node} [subTitleContent] - Optional custom subtitle content node.
 * @property {boolean} [disabled = false] - True if component should be disabled. The indicator icon will be hidden and component not clickable.
 * @property {Function} [onClick = ()=>{}] - Callback triggered on button click.
 * @property {node} [children] - Child components.
 * @property {boolean} [isExpanded = false] - A flag that should be set to true if the view should initially be expanded.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Presentation.Components.QuickNavigationButton
 */
const propTypes = {
    title: PropTypes.string,
    subTitle: PropTypes.string,
    subTitleContent: PropTypes.node,
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
    isExpanded: PropTypes.bool,
    class: PropTypes.string,
};

const defaultProps = {
    disabled: false,
    onClick: noop,
    isExpanded: false,
};

export default UIView('QuickNavigationButton', QuickNavigationButtonImpl, propTypes, defaultProps);
